import { Radio, Calendar, Clock, MapPin, Users, Mic } from "lucide-react";
import { EVENT, SPEAKERS, MODERATOR } from "@/data/eventData";

const YoutubeStream = () => {
  return (
    <div
      data-testid="youtube-stream-page"
      className="min-h-screen bg-[#0B1B3D] flex flex-col items-center px-5 py-14 sm:py-16"
    >
      <div className="w-full max-w-4xl">
        {/* Live indicator */}
        <div className="flex justify-center">
          <div
            data-testid="live-indicator"
            className="inline-flex items-center gap-2.5 rounded-full border border-[#D91C29]/40 bg-[#D91C29]/10 px-4 py-1.5"
          >
            <span className="relative flex h-3 w-3">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#D91C29] opacity-75" />
              <span className="relative inline-flex h-3 w-3 rounded-full bg-[#D91C29]" />
            </span>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-white">Live Stream</span>
            <Radio size={14} className="text-[#D91C29] animate-pulse" />
          </div>
        </div>

        {/* Heading */}
        <p className="mt-7 text-center text-sm sm:text-base uppercase tracking-[0.25em] text-[#D91C29] font-semibold">
          Panel Discussion On
        </p>
        <h1
          data-testid="youtube-stream-heading"
          className="mt-2 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-tight text-center"
        >
          Terms of Trade : India, Britain and Long Shadow of Empire
        </h1>

        {/* Video */}
        <div className="mt-9 w-full">
          <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl" style={{ paddingTop: "56.25%" }}>
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/-_TaYRRp6sU"
              title="Panel Discussion - Terms of Trade : India, Britain and Long Shadow of Empire"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Key information */}
        <div data-testid="stream-info" className="mt-12">
          <h2 className="font-serif-display text-2xl sm:text-3xl font-bold text-white">About this discussion</h2>
          <p className="mt-4 text-slate-300 leading-relaxed">{EVENT.description}</p>

          {/* Details */}
          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {[
              { icon: Calendar, label: "Date", value: EVENT.date },
              { icon: Clock, label: "Time", value: EVENT.time },
              { icon: MapPin, label: "Venue", value: EVENT.venue },
            ].map((d) => {
              const Icon = d.icon;
              return (
                <div key={d.label} className="rounded-xl border border-white/10 bg-white/5 p-5">
                  <div className="w-10 h-10 rounded-lg bg-[#D91C29] flex items-center justify-center">
                    <Icon size={18} className="text-white" />
                  </div>
                  <p className="mt-3 text-[11px] uppercase tracking-widest text-slate-400">{d.label}</p>
                  <p className="mt-1 font-semibold text-white leading-snug text-sm">{d.value}</p>
                </div>
              );
            })}
          </div>

          {/* Moderator */}
          <div className="mt-8 flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 p-5">
            <Mic size={18} className="text-[#D91C29] mt-0.5 shrink-0" />
            <div>
              <p className="text-[11px] uppercase tracking-widest text-slate-400">Moderated By</p>
              <p className="mt-1 font-semibold text-white">{MODERATOR.name}</p>
              <p className="text-sm text-slate-300">{MODERATOR.role}</p>
            </div>
          </div>

          {/* Speakers */}
          <div className="mt-8">
            <div className="flex items-center gap-2 text-slate-400">
              <Users size={16} className="text-[#D91C29]" />
              <span className="text-[11px] uppercase tracking-widest">The Panel</span>
            </div>
            <div className="mt-4 grid sm:grid-cols-2 gap-x-8 gap-y-3">
              {SPEAKERS.map((s) => (
                <div key={s.name} className="border-b border-white/10 pb-3">
                  <p className="font-semibold text-white leading-snug">{s.name}</p>
                  <p className="text-sm text-slate-400 leading-snug">{s.role}</p>
                </div>
              ))}
            </div>
          </div>

          <p className="mt-10 text-center text-sm text-slate-400">
            Organised by <span className="font-serif-display text-white font-semibold">Urzu Media Solutions</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default YoutubeStream;
